import ArtifactPage from "./ArtifactPage"

export default ArtifactPage;